<template>
  <main>
    <!-- Just here to test components -->
    <!-- <ReferenceComponent /> -->
    <h1>Adam's Programs</h1>
    <h3>Banana Republic:</h3>
    OHU
    <h3>Argent:</h3>
    Returns <br> Replen <br> Orders <br> Boxes <br> Barcodes

  </main>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}
</script>
